import React, {StrictMode} from 'react';
import redial from 'redial';
import {withLegacyProviders} from '../LegacyComponentWrapper';

import LegacyPage from '@aboutyou/legacy-desktop/src/app/pages/StoryOverview/StoryOverviewPage';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/StoryOverview/redial';

import {PageTrackingContextProvider} from '@aboutyou/legacy-desktop/src/app/helpers/tracking/PageTrackingContext';
import {useTrackingPageUrl} from '@aboutyou/legacy-desktop/src/app/helpers/tracking/hooks/useTrackingPageUrl';
import {TrackingPageTypeWithoutId} from '@aboutyou/legacy-tracking-sdk';
import {
  ProductMiniAdpWithBasketFlyout,
  SizeSelectionOpenedStateKey,
  useMiniAdpDialogOpenedState,
} from '@aboutyou/logic-components';

const TrackedStoryOverviewPage: React.FC<{
  openProductMiniADPDialog: ({
    productId,
    filteredSizeId,
    locationId,
  }: {
    productId: number;
    filteredSizeId?: number;
    locationId?: string;
  }) => void;
}> = ({openProductMiniADPDialog}) => {
  const {path, search} = useTrackingPageUrl();

  return (
    <PageTrackingContextProvider
      path={path}
      search={search}
      type={TrackingPageTypeWithoutId.StoryOverview}
    >
      <LegacyPage openProductMiniADPDialog={openProductMiniADPDialog} />
    </PageTrackingContextProvider>
  );
};

const PageWithRedial = redial.provideHooks(redialHandle)(
  TrackedStoryOverviewPage,
);

const StoryOverviewPageWithLegacyProviders =
  withLegacyProviders(PageWithRedial);

export const StoryOverviewPage: React.FC = () => {
  const {open: openProductMiniADPDialog} = useMiniAdpDialogOpenedState();

  return (
    <>
      <StoryOverviewPageWithLegacyProviders
        openProductMiniADPDialog={openProductMiniADPDialog}
      />

      <StrictMode>
        <ProductMiniAdpWithBasketFlyout
          showAddToWishlistButton
          sizeSelectionStateManagerKey={
            SizeSelectionOpenedStateKey.MAIN_SIZE_SELECTION
          }
        />
      </StrictMode>
    </>
  );
};
